// extracted by mini-css-extract-plugin
export default {"container":"_c32fbe52","searchTerm":"_35ca0b75"};